import { Accordion } from "flowbite-react"
  const SimproFAQ: React.FC = () => { return (
        <>
          <Accordion>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">What is simPRO?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  simPRO is a comprehensive field service management software designed to streamline and automate business operations. It offers features such as job management, scheduling, quoting, inventory management, invoicing, and more.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> How can simPRO benefit my business?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  simPRO can benefit your business by improving efficiency, enhancing communication, and centralizing your field service management processes. It allows for better job scheduling, real-time tracking, accurate quoting, streamlined invoicing, and comprehensive reporting, resulting in increased productivity and profitability.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title"> Is simPRO suitable for my industry?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  simPRO caters to various industries including electrical, plumbing, HVAC, security, and more. It can be customized to meet the specific needs of your industry, making it a versatile solution for businesses in the field service sector.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Can simPRO be integrated with other software systems?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Yes, simPRO can be integrated with other software systems such as accounting software, CRM platforms, project management tools, and more. This integration ensures seamless data flow and eliminates duplicate data entry, saving time and reducing errors.
                    </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">Do I need technical expertise to use simPRO?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  While simPRO offers robust functionality, it is designed to be user-friendly. The software provides intuitive interfaces and training resources to help users navigate and utilize its features effectively. However, some advanced configurations and customization may require technical expertise or the assistance of simPRO development experts.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How can custom simPRO development enhance my simPRO experience?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  Custom simPRO development allows you to tailor the software to match your specific business processes, workflows, and industry requirements. It enables you to add custom modules, integrate with other systems, create personalized reports, and optimize the software according to your unique needs, resulting in a more efficient and effective field service management solution.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
              <Accordion.Panel>
                <Accordion.Title as="h3"  className="accordion-title">How can I get started with simPRO development services?</Accordion.Title>
                <Accordion.Content className="accordion-border">
                  <div className="fs-md mb-0 text-secondary">
                  To get started with simPRO development services, reach out to a trusted simPRO development company like Moweb Limited. We can discuss your project requirements, provide insights, offer a consultation, and develop a tailored plan to meet your needs. Contact us today to begin enhancing your simPRO experience.
                  </div>
                </Accordion.Content>
              </Accordion.Panel>
            </Accordion>
        </>
        )
}

export default SimproFAQ
